module.exports = __webpack_public_path__ + "static/desktop-house-a22c357041ea79ddcbdcd4a1b3808784.png";